(ns manage.poi.selectors.form
  (:require ["@mui/material/Stack$default" :as Stack]
            [cljs-bean.core :refer [->clj]]
            [common.form :as form]
            [common.widgets.form-field :refer [form-field]]
            [uix.core :refer [$]]))

(defn selector-default-values [selector]
  (let [data (:data selector)]
    #js {:name (:name data)
         :all-labels (to-array (:all-labels data))
         :any-labels (to-array (:any-labels data))
         :not-all-labels (to-array (:not-all-labels data))
         :not-any-labels (to-array (:not-any-labels data))}))

(defn build-selector-payload [^js form-data]
  (let [d (->clj form-data)]
    {:name (:name d)
     :all-labels (vec (:all-labels d))
     :any-labels (vec (:any-labels d))
     :not-all-labels (vec (:not-all-labels d))
     :not-any-labels (vec (:not-any-labels d))}))

(defn empty-selector-defaults []
  #js {:name ""
       :all-labels #js []
       :any-labels #js []
       :not-all-labels #js []
       :not-any-labels #js []})

(defn selector-form-fields [{:keys [control label-options auto-focus?]}]
  ($ Stack {:spacing 2}
     ($ form-field {:label "Name" :required? true}
        ($ form/form-text-field {:name "name" :control control
                                 :rules #js {:required "Required"}
                                 :field-props {:size "small" :autoFocus (boolean auto-focus?)}}))
     ($ form-field {:label "Include POI with any of"}
        ($ form/autocomplete-field
           {:name "any-labels"
            :control control
            :field-props {:options label-options
                          :multi? true
                          :placeholder "Select labels..."}}))
     ($ form-field {:label "Include POI with all of"}
        ($ form/autocomplete-field
           {:name "all-labels"
            :control control
            :field-props {:options label-options
                          :multi? true
                          :placeholder "Select labels..."}}))
     ($ form-field {:label "Exclude POI with any of"}
        ($ form/autocomplete-field
           {:name "not-any-labels"
            :control control
            :field-props {:options label-options
                          :multi? true
                          :placeholder "Select labels..."}}))
     ;; XXX not-all-labels is not configurable on purpose. its meaning
     ;; is hard to explain to users.
     ))
